module.exports = __webpack_public_path__ + "static/media/landing.8ad554f5.svg";